<template>
  <div id="home_wrapper">
    <div class="home">
      <!-- App NAVIGATION COMPONENT -->
      <AppNavigation />
      <!-- HERO COMPONENT -->
      <Hero />
    </div>
    <!-- ABOUT COMPONENT -->
    <About />
    <!-- THE INSTITUTE -->
    <TheInstitute />
    <!-- CONTACT US -->
    <Contact />
    <!-- APP FOOTER COMPONENT -->
    <AppFooter />
  </div>
</template>

<script>
import AppNavigation from "../components/AppNavigation";
import AppFooter from "../components/AppFooter";
import Hero from "../views/Hero.vue";
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";
import TheInstitute from "../views/TheInstitute";

export default {
	name: "Home",
	components: {
		AppNavigation: AppNavigation,
		AppFooter: AppFooter,
		Hero: Hero,
		About: About,
		Contact: Contact,
		TheInstitute: TheInstitute,
	},
};
</script>
<style lang="scss">
#home_wrapper {
  width: 100%;

  #hero {
    background: rgb(196, 5, 5);
    background-image: url("../assets/images/hero.jpg");
    width: 100%;
    margin-top: 101px;
    height: calc(100vh - 101px);
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .hero-text {
      color: #fff;
      text-align: center;

      h2 {
        font-weight: 500;
        font-size: 3.7em;
      }

      p.sub-text {
        font-size: 1.2em;
      }
    }
  }
}
</style>
